import { Component, OnInit } from '@angular/core';
import { PatientPortalService } from 'src/app/core/services/patient-portal.service';
import { Invoice, ApiResponse } from 'src/app/core/models/patientportal';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-myinvoices',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './myinvoices.component.html',
  styleUrl: './myinvoices.component.scss'
})
export class MyinvoicesComponent implements OnInit {

  invoices: Invoice[] = [];
  loading = false;

  // 🔥 modal
  modalOpen = false;
  selectedInvoice: any = null;
  detailsLoading = false;

  // =========================
  // UI STATE
  // =========================
  view: 'table' | 'grid' = 'table';

  // filters
  q: string = '';
  status: string = '';
  from: string = '';
  to: string = '';

  // stats (KPI)
  stats = {
    totalRevenue: 0,
    paid: 0,
    pending: 0,
    overdue: 0
  };

  // selected invoice for detail view
  invoice: any = null;

  calculateStats() {
    let total = 0;
    let paid = 0;
    let pending = 0;
    let overdue = 0;

    for (let i of this.invoices) {
      total += i.grandTotal;

      if (i.status === 'PAID') {
        paid += i.grandTotal;
      }

      if (i.status === 'OPEN' || i.status === 'PROCESSING') {
        pending += i.grandTotal;
      }

      if (i.status === 'OVERDUE') {
        overdue += i.grandTotal;
      }
    }

    this.stats = {
      totalRevenue: total,
      paid,
      pending,
      overdue
    };
  }

  constructor(private service: PatientPortalService) { }

  ngOnInit(): void {
    this.fetchInvoices();
  }

  fetchInvoices() {
    this.loading = true;

    this.service.getInvoices().subscribe({
      next: (res: ApiResponse<any>) => {
        this.invoices = res.data.invoices || [];

        this.calculateStats(); // 🔥 ADD THIS

        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  openInvoice(id: string) {
    this.modalOpen = true;
    this.detailsLoading = true;

    this.service.getInvoiceById(id).subscribe({
      next: (res) => {
        this.selectedInvoice = res.data.invoice;

        this.invoice = this.selectedInvoice; // 🔥 ADD THIS

        this.detailsLoading = false;
      },
      error: () => this.detailsLoading = false
    });
  }

  closeModal() {
    this.modalOpen = false;
  }

  get filteredInvoices() {
    return this.invoices.filter(i => {

      const matchStatus = this.status ? i.status === this.status : true;

      const matchSearch = this.q
        ? i.invoiceNo.toLowerCase().includes(this.q.toLowerCase()) ||
        i.orderId?.orderNo?.toLowerCase().includes(this.q.toLowerCase())
        : true;

      return matchStatus && matchSearch;
    });
  }

  getStatusClass(status: string) {
    return {
      paid: status === 'PAID',
      pending: status === 'OPEN' || status === 'PROCESSING',
      failed: status === 'FAILED',
      refunded: status === 'REFUNDED'
    };
  }
}